export interface IAmenity {
    id: number;
    name: string;
    internalId: string;
    uses: string[];
    enableStatus: 0|1;
    allowResidentsToBook: 0|1;
    requiresManagerApproval: 0|1;
    legalAgreement: string;
    legalAgreementStatus: 0|1;
    legalAgreementHideFromStaffInterface: 0|1;
    confirmationMessage: string;
    disclaimer: string;
    disclaimerStatus: 0|1;
    disclaimerHideFromStaffInterface: 0|1;
    timeSequenceType: AmenityTimeSequence;
    amenityImage: string;
    amenityColor: string;
    buildingAmenity: any[]; // todo
    disabledDates: any[]; // todo
    fees: any[]; // todo: IFeeType
    paymentStatus: 0|1;
    paymentCustomTypeName: string;
    paymentAcceptCheques: 0|1;
    paymentAcceptCreditCards: 0|1;
    paymentAcceptCustomType: 0|1;
    paymentAcceptCash: 0|1;
    paymentAcceptCertifiedCheque: 0|1;
    paymentAcceptMoneyOrder: 0|1;
    paymentAcceptBankDraft: 0|1;
    defaultPaymentMethod: AmenityPaymentMethod;
    holdDayTo: number;
    holdDayFrom: number;
    bookingCancelledExpiredHours: number;
    multipleBooking: 0|1;
    multipleBookingMaxCount: number;
    managementOverride: 0|1;
    maxTimeForAdvancedBooking: string;
    minTimeForAdvancedBooking: string;
    notifyStaff: 0|1; // todo: not described in API docs
    notifyResidents: 0|1;
    reminders: any[]; // todo: Reminder interface
    staffNotificationSettings: any[]; // todo describe
    residentsNotificationSettings: any[]; // todo describe
    userGroups: any[]; // todo describe
    residentOccupancyTypes: any []; // todo describe
    createdAt: string;
    createdBy: any; // todo describe
    autoApproveAfterPayment: 0|1;
    customStripeAccount: string;
    rule: any; // todo describe
    bookings: any[]; // not described in API doc
}

export enum AmenityTimeSequence {
    Daily = 'daily',
    Hourly = 'hourly',
    Range = 'range',
}

export enum AmenityPaymentMethod {
    cash = 'cash',
    cheque = 'cheque',
    credit_card = 'credit_card',
    custom_type  = 'custom_type',
    certified_cheque = 'certified_cheque',
    money_order = 'money_order',
    bank_draft = 'bank_draft',
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/amenity/amenity.ts